import { CustomerProps } from '@pages/e-signature';
import { FeedBlog } from 'models/Home.model';
import { createContext, useContext } from 'react';

export interface ESignatureState {
  customers: CustomerProps[];
  highlightBlogs: FeedBlog[];
}

export const ESignatureContext = createContext<ESignatureState>({
  customers: [],
  highlightBlogs: [],
});

export const useESignatureContext = () => {
  return useContext(ESignatureContext);
};
